import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import Banner from '@/components/ui/banner';
import { TriangleAlert } from 'lucide-react';
import { BANNER_TITLE, DESCRIPTION } from './delete-space-member.constant';
import { useDeleteSpaceMemberModal } from './use-delete-space-member-modal';
import {
  ModalCloseButton,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';

export type TDeleteSpaceMemberModalType = 'DeleteSpaceMemberModal';
export interface IDeleteSpaceMemberModalProps {
  userId: string;
  spaceId: string;
  organizationId: string;
}

const DeleteSpaceMemberModal = memo((props: IDeleteSpaceMemberModalProps) => {
  const {
    // Form
    form,

    // Modal
    isOpenDeleteSpaceMemberModal,

    // Helpers
    isDisabledForm,
    isLoadingForm,

    // Handlers
    handleClose,
    handleSubmitForm,
  } = useDeleteSpaceMemberModal({
    userId: props.userId,
    spaceId: props.spaceId,
    organizationId: props.organizationId,
  });

  return (
    <Modal
      isOpen={isOpenDeleteSpaceMemberModal}
      lockBodyScroll
      onClose={handleClose}
      isCloseOutside={false}
      className="p-[32px] md:w-[500px] w-[345px]"
    >
      <ModalHeader>
        <ModalTitle>Delete Space Member</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="delete-space-member-form"
          className="grid gap-[4px]"
        >
          <Banner className="my-[8px]" icon={TriangleAlert} title={BANNER_TITLE} variant="warning" />
          <div className="text-[14px] font-normal text-[#9D9D9C]">{DESCRIPTION}</div>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleClose();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="delete-space-member-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner isLoading={true} className="w-[18px] h-[18px]" /> : null} Delete
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
DeleteSpaceMemberModal.displayName = 'DeleteSpaceMemberModal';

export default DeleteSpaceMemberModal;
